import { CompanyContextServiceBase } from '../../../company-context';
import { Interceptor, InterceptorRequestConfig } from '../http.service';
import { Tags } from './../../../web';

export const ApiConfig = {
    baseUrl: `https://${location.host}/gw`
} as const;


export function httpRequestInterceptor(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            if (config.taggedUrl.hasTag(Tags.Api)) {
                config.url = `${ApiConfig.baseUrl}/api/v1/${config.url}`;
            } else if (config.taggedUrl.hasTag(Tags.SelloApi)) {
                config.url = `${ApiConfig.baseUrl}/api/${config.url}`;
            } else {
                config.url = `${ApiConfig.baseUrl}/${config.url}`;
            }

            if (config.headers) {
                (config.headers as Record<string, unknown>)['su123-tenant-cid'] = CompanyContextServiceBase.companyContext?.tenantCorrelationId || '';
            }
        }
    };
}
